export const RECEIVE_VARIABLE_SERVER = 'RECEIVE_VARIABLE_SERVER';
export const PRE_PATCH_VARIABLE = 'PRE_PATCH_VARIABLE';
export const PATCH_VARIABLE = 'PATCH_VARIABLE';
export const PRE_UPDATE_SESSION = 'PRE_UPDATE_SESSION';
